import gql from 'graphql-tag'

export const updateDeal = gql`
  mutation updateDeal($id: Int!, $idProcessStatus: Int!, $idClosingReason: Int!) {
    update_crm_deal(where: {id: {_eq: $id}}, _set: {id_process_status: $idProcessStatus, id_closing_reason: $idClosingReason}) {
      affected_rows
    }
  }
`
